
import {
  COLOR_TEMPERATURE_REFERENCES,
  COLOR_TEMPERATURE_SCALE,
  COLOR_TEMPERATURE_TONES,
  colorTemperatureGradient,
  colorTemperaturePosition,
  colorTemperatureTone,
  formatColorTemperature,
} from '@/utils/colorTemperature'

export default {
  name: 'ColorTemperatureScale',
  props: {
    kelvin: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      scale: COLOR_TEMPERATURE_SCALE,
      references: COLOR_TEMPERATURE_REFERENCES,
    }
  },
  computed: {
    gradient() {
      return colorTemperatureGradient(COLOR_TEMPERATURE_SCALE)
    },
    currentTone() {
      return this.kelvin ? colorTemperatureTone(this.kelvin) : null
    },
    tones() {
      return COLOR_TEMPERATURE_TONES
    },
  },
  methods: {
    formatColorTemperature,
    position(kelvin) {
      return colorTemperaturePosition(kelvin, COLOR_TEMPERATURE_SCALE)
    },
  },
}
